import React from 'react';
import { Tables } from '@deeptrue-frontend/ui';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveModal from 'components/PromptModal/PromptModal';
import { useFormatMessage } from 'components/IntlProvider';

const { TableRow, TableCell } = Tables;

interface Props {
  workbench: string;
  name: string;
  id: number;
  removeProduct: (id: number) => void;
}

const Product = ({ name, workbench, id, removeProduct }: Props) => {
  const t = useFormatMessage();
  return (
    <TableRow>
      <TableCell minWidth="150px" height="2rem" padding="0.5rem">
        {name}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {workbench}
      </TableCell>

      <TableCell height="2rem" padding="0.5rem" width="80px" align="right">
        <Tooltip title={t('organization.unshare', 'Unshare')}>
          <span style={{ cursor: 'pointer' }}>
            <RemoveModal
              onConfirm={() => removeProduct(id)}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              <>
                {t(
                  'organization.confirmUnshare',
                  'Are you sure you want to unshare this {x}',
                  {
                    x: t('organization.product', 'Product'),
                  }
                )}
              </>
            </RemoveModal>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default Product;
